"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetAuthUser = exports.updateAuthUser = exports.parseAuthUser = void 0;
var effector_logger_1 = require("effector-logger");
var md5_1 = require("ts-md5/dist/md5");
var blankAuthUser = {
    username: "loading..",
    email: "loading..",
    gravatar: "/noicon.jpeg",
    isGoogle: false,
    isLoggedIn: false,
    isAdmin: false,
    isAgent: false,
    isAuthorized: false,
    groups: [],
};
var doParseAuthUser = function (state, user) {
    user.getSession(function (e, s) {
        var _a, _b, _c, _d, _e;
        if (!e && s) {
            state.isLoggedIn = true;
            state.email = (_b = (_a = s.idToken) === null || _a === void 0 ? void 0 : _a.payload) === null || _b === void 0 ? void 0 : _b.email;
            state.username = (_c = s.idToken) === null || _c === void 0 ? void 0 : _c.payload["cognito:username"];
            state.gravatar = "https://gravatar.com/avatar/" + md5_1.Md5.hashStr(state.email);
            state.groups = s.idToken.payload["cognito:groups"];
            ///check for admin auth
            for (var _i = 0, _f = state.groups; _i < _f.length; _i++) {
                var g = _f[_i];
                if (g.endsWith("group-admin")) {
                    state.isAuthorized = true; /// remove this, here for backwards compat
                    state.isAdmin = true;
                }
                if (g.endsWith("group-admin")) {
                    state.isAgent = true;
                }
            }
            ///check for google
            for (var _g = 0, _h = (_e = (_d = s.idToken) === null || _d === void 0 ? void 0 : _d.payload) === null || _e === void 0 ? void 0 : _e.identities; _g < _h.length; _g++) {
                var g = _h[_g];
                if (g.providerName === "Google") {
                    state.isGoogle = true;
                }
            }
        }
    });
};
exports.parseAuthUser = (0, effector_logger_1.createEvent)();
exports.updateAuthUser = (0, effector_logger_1.createEvent)();
exports.resetAuthUser = (0, effector_logger_1.createEvent)();
exports.default = (0, effector_logger_1.createStore)(blankAuthUser)
    .on(exports.resetAuthUser, function (state) { return blankAuthUser; })
    .on(exports.updateAuthUser, function (state, _a) {
    var userinfo = _a.userinfo;
    return (__assign(__assign({}, state), userinfo));
})
    .on(exports.parseAuthUser, function (state, cognitoUser) {
    if (cognitoUser) {
        doParseAuthUser(state, cognitoUser);
    }
    return __assign({}, state);
});
//# sourceMappingURL=data:application/json;base64,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